import { observer } from "mobx-react";
import React, { useState } from "react";
import styles from "../settings/settingsEditCommon.css";
import { AiGeneralSettings } from "../../components/ai/generalSettings";
import { AiModelConfiguration } from "../../components/ai/modelConfiguration/modelConfiguration";
import { AiTestingTab } from "../../components/ai/testingTab/testingTab";
import { DashboardView } from "../dashboard/views/DashboardView";
import { IntentWithDatasetInfoFormType } from "../../components/ai/modelConfiguration/types";
import { SettingsListFilterProvider } from "../../components/settings/settingsForms/filters/useListFilter/useListFilter";

export interface Props {
  view: DashboardView;
}

export const AiSuggestionsContent = observer(({ view }: Props) => {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement>();

  const resetScrollOffset = () => {
    scrollElement?.scrollTo({ top: 0 });
  };

  const renderContent = () => {
    switch (view) {
      case DashboardView.AI_SETTINGS_GENERAL:
        return <AiGeneralSettings />;
      case DashboardView.AI_SETTINGS_MODEL_CONFIGURATION:
        return (
          <SettingsListFilterProvider<IntentWithDatasetInfoFormType>>
            <AiModelConfiguration resetScrollOffset={resetScrollOffset} />
          </SettingsListFilterProvider>
        );

      case DashboardView.AI_SETTINGS_TESTING:
        return <AiTestingTab resetScrollOffset={resetScrollOffset} />;

      default:
        return;
    }
  };

  const render = () => (
    <div
      className={styles["container-scroll"]}
      ref={(el) => setScrollElement(el as HTMLDivElement)}
    >
      <div className={styles.container}>{renderContent()}</div>
    </div>
  );

  return render();
});
